const titleHandler = title => {
  document.title = '';
  document.title = title;
};
export default titleHandler;
